module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAxElEQVRYhe2XOwoCMRRFzwyjnSDuQFyUC7BxGy7EYlbgBywsxMZVCOICFNRu8IMyoJAJkw/CJM07XV5C3gnvNklQOEyPb5rnNhj1u78uaYCGVkRABERABERABERABEQghkBqXASiFVsgiy0QfQSVv0imbV48L+k45BO9kcLTJtDzFGhbGpQMgbym/gIWNgFf7o5zhaF+BuZqoakMmB62AVYhBOrYARPgGkJAzccDmAFjYK8f/DcDLsqMnIAtsATW3/lXAT6DCRkyOZpXLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/branding/tellit/logo32x32.png
// module id = 647
// module chunks = 0